import { API, axiosInstance } from "lib";

export const getActiveSessions= (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append('userId', data?.userId || '');
  queryParams.append('page', data?.page);
  queryParams.append('limit', data?.limit);
  queryParams.append('isActive', data?.isActive);
  queryParams.append('startDate', data?.startDate);
  queryParams.append('endDate', data?.endDate);

  return axiosInstance
    .get(`${API.GET_ACTIVE_SESSIONS}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const removeLoginSession = (data = {}) => {
  return axiosInstance
    .post(API.REMOVE_LOGIN_SESSIONS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
      }
      throw err;
    });
};
